import Page from 'components/modules/public/pages/CompanySite';
export default Page;